import { Type } from '@angular/core';
import { SidePanelService } from '../services/side-panel.service';

/**
 * A reference to an open side panel.
 * It can be injected into the content component.
 * It acts as a "remote control" for the panel, allowing the
 * content component to close itself and return a result.
 */
export class SidePanelRef<T = any, R = any> {

  constructor(
    private sidePanelService: SidePanelService,
    public readonly data: T
  ) {}

  /**
   * Closes the panel and returns a result to the opener.
   * @param result The data to return.
   */
  public close(result?: R): void {
    this.sidePanelService.close(result);
  }

  /**
   * Dismisses the panel without returning a result.
   */
  public dismiss(): void {
    this.sidePanelService.dismiss();
  }

  /**
   * Navigates to the next step in the workflow.
   * @param component The component class for the next step.
   * @param data Optional data to pass to the next step.
   */
  public navigateForward<T>(component: Type<T>, data?: any): void {
    this.sidePanelService.navigateForward(component, data);
  }

  /**
   * Navigates to the previous step in the workflow.
   */
  public navigateBack(): void {
    this.sidePanelService.navigateBack();
  }
}